/* Open header dropdowns on hover (desktop only). */
(function () {
  const HOVER_MIN_WIDTH = 990; // matches Dawn's desktop breakpoint
  const CLOSE_DELAY = 120;

  function bindHoverDetails(container) {
    const details = container.querySelector(':scope > details');
    if (!details) return;

    let closeTimer;

    const open = () => {
      if (window.matchMedia('(hover: none)').matches) return;
      if (window.innerWidth < HOVER_MIN_WIDTH) return;
      clearTimeout(closeTimer);
      details.open = true;
    };

    const scheduleClose = () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        details.open = false;
      }, CLOSE_DELAY);
    };

    container.addEventListener('mouseenter', open);
    container.addEventListener('mouseleave', scheduleClose);
    container.addEventListener('focusin', open);
    container.addEventListener('focusout', (event) => {
      if (!container.contains(event.relatedTarget)) scheduleClose();
    });
  }

  function init() {
    document.querySelectorAll('header-menu, .mega-menu').forEach((el) => {
      // mega-menu is itself a <details>, not a wrapper. Handle both shapes.
      if (el.tagName.toLowerCase() === 'details') {
        let closeTimer;
        const open = () => {
          if (window.matchMedia('(hover: none)').matches) return;
          if (window.innerWidth < HOVER_MIN_WIDTH) return;
          clearTimeout(closeTimer);
          el.open = true;
        };
        const scheduleClose = () => {
          clearTimeout(closeTimer);
          closeTimer = setTimeout(() => {
            el.open = false;
          }, CLOSE_DELAY);
        };
        el.addEventListener('mouseenter', open);
        el.addEventListener('mouseleave', scheduleClose);
        el.addEventListener('focusin', open);
        el.addEventListener('focusout', (event) => {
          if (!el.contains(event.relatedTarget)) scheduleClose();
        });
      } else {
        bindHoverDetails(el);
      }
    });
  }

  // ---- Click-to-navigate on top-level summaries ----
  function navOnClick(e) {
    const summary = e.target.closest('summary[data-nav-href]');
    if (!summary) return;
    if (window.innerWidth < HOVER_MIN_WIDTH) return; // mobile: keep toggle behavior
    const url = summary.dataset.navHref;
    if (!url || url === '#') return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = url;
  }
  document.addEventListener('click', navOnClick);

  // ---- Mega-dropdown: hover-swap secondary column ----
  function initMega(panel) {
    const host = panel.querySelector('[data-mega-secondary-host]');
    const rows = panel.querySelectorAll('[data-mega-row]');
    if (!host || !rows.length) return;

    function setActive(row) {
      rows.forEach((r) => r.classList.toggle('is-active', r === row));
      const tpl = row.querySelector('template[data-secondary-content]');
      host.innerHTML = '';
      if (tpl && tpl.content) {
        host.appendChild(tpl.content.cloneNode(true));
      }
    }

    rows.forEach((row) => {
      row.addEventListener('mouseenter', () => setActive(row));
      row.addEventListener('focusin', () => setActive(row));
    });

    // Default to the first row that has a secondary list.
    const firstWithSecondary = Array.from(rows).find((r) =>
      r.querySelector('template[data-secondary-content]')
    );
    if (firstWithSecondary) setActive(firstWithSecondary);
  }

  function initAllMega() {
    document.querySelectorAll('.header-mega__panel').forEach(initMega);
  }

  // ---- Page overlay while a mega-dropdown is open ----
  function ensureOverlay() {
    let el = document.querySelector('.header-mega__overlay');
    if (!el) {
      el = document.createElement('div');
      el.className = 'header-mega__overlay';
      el.setAttribute('aria-hidden', 'true');
      document.body.appendChild(el);
    }
    return el;
  }
  function updateOverlay() {
    const overlay = ensureOverlay();
    const anyOpen = document.querySelector('details.header-mega[open]');
    overlay.classList.toggle('is-active', !!anyOpen);
  }
  function watchMegaDetails() {
    document.querySelectorAll('details.header-mega').forEach((d) => {
      if (d.__megaWatched) return;
      d.__megaWatched = true;
      // Toggle event (capture, since it doesn't bubble).
      d.addEventListener('toggle', updateOverlay);
      // Belt-and-braces: watch the `open` attribute directly.
      const obs = new MutationObserver(updateOverlay);
      obs.observe(d, { attributes: true, attributeFilter: ['open'] });
    });
    updateOverlay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { init(); initAllMega(); watchMegaDetails(); });
  } else {
    init();
    initAllMega();
    watchMegaDetails();
  }
  document.addEventListener('shopify:section:load', () => { init(); initAllMega(); watchMegaDetails(); });
})();
